module.exports = __webpack_public_path__ + "img/germany-transport-accidents-male.fcf1ee4f.png";